import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import {t} from "../common/i18n.js";
import {formatCurrency} from "../common/universal.js";
import {withAttrs} from "../common/utils.js";
import Collapse from "./collapse.js";
import Stack from "./stack.js";
import {fontFamily, lineHeight, media} from "./theme.js";
export default function ProductPriceOverview(props) {
  const {collapsible, stepConfig} = props;
  if (collapsible || stepConfig) {
    return /* @__PURE__ */ React.createElement(Collapse, {
      header: /* @__PURE__ */ React.createElement(Header, {
        ...props
      }),
      collapsed: true,
      hideIcon: true
    }, /* @__PURE__ */ React.createElement(Details, {
      ...props
    }));
  }
  return /* @__PURE__ */ React.createElement(Container, {
    ...props
  }, /* @__PURE__ */ React.createElement(Header, {
    ...props
  }), /* @__PURE__ */ React.createElement(Details, {
    ...props
  }));
}
function Header(props) {
  const {overallPrice, stepConfig, ...rest} = props;
  return /* @__PURE__ */ React.createElement(Section, {
    ...rest
  }, /* @__PURE__ */ React.createElement(OverallLabel, {
    stepConfig
  }, t("Gesamtpreis (Netto)")), /* @__PURE__ */ React.createElement(OverallValue, {
    stepConfig
  }, format(overallPrice)));
}
function Details(props) {
  const {
    unitPrice,
    overallPrice,
    standardShippingPrice,
    optionsPrice = 0,
    diecutPrice = 0,
    overallPriceWithTaxes,
    ...rest
  } = props;
  const isFreeProduct = unitPrice === 1 && standardShippingPrice === null && overallPrice === null;
  if (isFreeProduct) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Inner, {
    ...rest
  }, /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(Label, null, t("Stückpreis (Netto)")), /* @__PURE__ */ React.createElement(Value, null, format(unitPrice))), optionsPrice > 0 && /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(Label, null, t("Produktoptionen (Netto)")), /* @__PURE__ */ React.createElement(Value, null, format(optionsPrice))), /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(Label, null, t("Versandkosten nach DE (Netto)")), /* @__PURE__ */ React.createElement(Value, null, format(standardShippingPrice))), diecutPrice > 0 && /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(Label, null, t("Stanzkontur (Netto)")), /* @__PURE__ */ React.createElement(Value, null, format(diecutPrice))), /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(Label, null, t("Gesamtpreis (Brutto)")), /* @__PURE__ */ React.createElement(Value, null, format(overallPriceWithTaxes))));
}
function format(n) {
  return n !== void 0 ? formatCurrency(n) : "-";
}
const Container = styled.div``;
const Inner = styled(withAttrs(Stack, {spacing: "xs"}))`
  padding-top: 12px;
`;
const Section = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Label = styled.div`
  font-family: ${fontFamily.primary};
  font-size: 14px;
  line-height: ${lineHeight};
`;
const Value = styled(Label)``;
const OverallLabel = styled(Label)`
  font-family: ${fontFamily.secondary};
  text-transform: uppercase;
  font-weight: bold;

  ${({stepConfig}) => stepConfig && `
    text-transform: none;
    font-size: 20px;

    ${media.mobile} {
      font-size: 18px;
    }
  `}
`;
const OverallValue = styled(OverallLabel)`
  font-family: ${fontFamily.secondary};
  font-weight: bold;
  font-size: 24px;
  text-transform: none;

  ${({stepConfig}) => stepConfig && `
    font-size: 20px;
  `}
`;
